import {DeviceHandler} from "../../../js_sdk/src/devices/device_handler";

export class DefaultDeviceHandler extends DeviceHandler {

	collisionHandler

	constructor(props) {
		super(props);
	}


	checkCameraCollision(camera, scene) {
		//STUB
	}

	bindCollision(collisionHandler) {
		this.collisionHandler = collisionHandler
	}

	reset() {
		//
	}
}